import { newOrderLista } from "global/utils/orderData";
import { useContext, useState } from "react";
import AddIcon from "_+_Portal/assets/images/generico/AddIcon";
import EditIcon from "_+_Portal/assets/images/generico/EditIcon";
import TrashIcon from "_+_Portal/assets/images/generico/TrashIcon";
import {
  wsDelete,
  wsGetAbm,
  wsPostAbm,
  wsPutAbm,
} from "_+_Portal/_-_Admin/context/action/Abm/abm";
import { AdminContext } from "_+_Portal/_-_Admin/context/Provider";
import { ContainerHeader, Input, LeftZone, RightZone } from "./localStyle";

const Abm = ({ configAbm }) => {
  //#region -------- useContext --------------
  const { abmState, abmDispatch } = useContext(AdminContext);
  //#endregion ------ useContext --------------

  //#region -------- useState --------------
  // Crear y editar nuevo item
  const [form, setForm] = useState({});

  const [type, setType] = useState(false);
  //#endregion ------ useState --------------

  //#region -------- constants -------------
  const idSelected = abmState.abm.selectedItem || false;
  //#endregion ----- constants -------------

  //#region -------- funtions -------------
  // Eliminar un item
  const deleteItem = () => {
    wsDelete(
      configAbm.urls[3],
      idSelected,
      abmState.abm.data.data, 
    )(abmDispatch);
  };

  

  const handleClickForm = (type, id) => {
    if (type === "PUT") {
      const newForm = abmState.abm.data.data.filter(
        (e) => Number(e.id) === Number(id)
      );
      if (newForm.length !== 0) {
        setForm(newForm[0]);
        setType(type);
      } else {
        setForm({});
        setType(false);
      }
    } else setType(type);
  };
  const submitFormCreate = (form) => {
    wsPostAbm(configAbm.urls[1], form, abmState.abm.data.data)(abmDispatch);
    setType(false);
  };

  const submitFomPut = (form) => {
    wsPutAbm(configAbm.urls[2], form, abmState.abm.data.data)(abmDispatch);
    setType(false);
  };
  //#endregion ----- funtions -------------

  return (
    <>
      {type ? (
        <configAbm.Abm
          type={type}
          setType={setType}
          submitFormCreate={submitFormCreate}
          submitFomPut={submitFomPut}
          form={form}
        />
      ) : (
        ""
      )}
      <ContainerHeader>
        <LeftZone>
          <ul>
            {/* <li onClick={handleClick}><input onChange={()=>{}} checked={idSelected === "ALL"? true: false}  type="checkbox" id="checkboxTable-1"/></li> */}
            <li onClick={() => handleClickForm("POST")}>
              <AddIcon />
            </li>
            <li onClick={() => handleClickForm("PUT", idSelected)}>
              <EditIcon />
            </li>
            <li onClick={deleteItem}>
              <TrashIcon />
            </li>
          </ul>
        </LeftZone>
        {/* <RightZone>
          <Input placeholder={"Buscador..."} onChange={searchItem} />
        </RightZone> */}
      </ContainerHeader>
    </>
  );
};

export default Abm;
